import { render, staticRenderFns } from "./ViewerSpinnerLoader.vue?vue&type=template&id=d8475aee&scoped=true"
import script from "./ViewerSpinnerLoader.vue?vue&type=script&lang=js"
export * from "./ViewerSpinnerLoader.vue?vue&type=script&lang=js"
import style0 from "./ViewerSpinnerLoader.vue?vue&type=style&index=0&id=d8475aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8475aee",
  null
  
)

export default component.exports